import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, inject, input, output, OnChanges, SimpleChanges} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {ActivatedRoute} from '@angular/router';
import {SafeResourceUrl} from '@angular/platform-browser';
import {LessonsConfigurationService} from '@modules/activities/core/lessons/services/lessons-configuration.service';
import {CommunicationCenterService} from '@modules/communication-center';

type Platform = {
    new(task): Platform;
    updateDisplay: (data, success, error) => void;
    openUrl: (sTextId, success, error) => void;
    validate: (mode, success, error) => void;
}

declare var TaskProxyManager: any;
declare var Platform: Platform;

@Component({
    selector: 'app-demo-external',
    imports: [
        MatCardModule,
    ],
    templateUrl: './demo-external.component.html'
})
export class DemoExternalComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
    public platformValidate = input<(mode, success, error) => void>((mode, success) => {success()})
    public platformOpenUrl = input<(sTextId, success, error) => void>((sTextId, success) => {success()})
    public platformUpdateDisplay = input<(data, success, error) => void>(() => undefined)

    public iframeUrl = input<SafeResourceUrl>(null);

    // output event when activity is done
    public activityDone = output<void>();


    @ViewChild('iframeViewport', {static: true}) iframeViewport: ElementRef;
    @ViewChild('iframeView') iframeView: ElementRef;


    protected activatedRoute = inject(ActivatedRoute);
    protected communicationCenter = inject(CommunicationCenterService);
    private lessonsConfigurationService = inject(LessonsConfigurationService);


    public platform: Platform;
    public isSizeInitDone = false;
    private isFullscreen = false;

    @HostListener('fullscreenchange', ['$event'])
    @HostListener('webkitfullscreenchange', ['$event'])
    @HostListener('mozfullscreenchange', ['$event'])
    @HostListener('MSFullscreenChange', ['$event'])
    screenChange(_event): void {
        this.isFullscreen = !this.isFullscreen;
        this.onIframeSizeChange();
    }

    @HostListener('window:resize', ['$event'])
    onResize(): void {
        this.onIframeSizeChange();
    }

    /***** Lifecycle Hooks *****/

    ngOnInit(): void {
        // close sidebar panel when start activity
        this.communicationCenter
            .getRoom('verticalSidebar')
            .getSubject('openOrFoldSidebar')
            .next(false);
        window.addEventListener('message', this.onMessageReceived, false);
    }

    ngOnChanges(changes:SimpleChanges) {
        if (changes['iframeUrl'] && !changes['iframeUrl'].firstChange) {
            this.platform = null;
        }
    }

    ngAfterViewInit(): void {
        this.onIframeSizeChange();
    }

    ngOnDestroy(): void {
        window.removeEventListener('message', this.onMessageReceived);
        this.communicationCenter
            .getRoom('verticalSidebar')
            .getSubject('openOrFoldSidebar')
            .next(true);
    }

    public onIframeLoad(): void {
        // todo Je comprends pas vraiment, peut etre qu'il faudra le déplacer dans le project citizen-code
        if (this.lessonsConfigurationService.settings.APIPEMTask && !this.platform) {
            TaskProxyManager.getTaskProxy('taskIframe', (task) => {
                this.platform = new Platform(task);
                TaskProxyManager.setPlatform(task, this.platform);
                task.getMetaData((metaData) => {
                    this.platformLoad(task, this.platform, metaData);
                });
            }, true);
        }
    }

    /***** Logic *****/

    /**
     * resize the image according to its frame/viewport (in reality it's container iframe will take the same size automatically)
     */

    private platformLoad(task, platform, metaData): void {
        this.platform.updateDisplay = this.platformUpdateDisplay()
        this.platform.openUrl = this.platformOpenUrl()
        this.platform.validate = this.platformValidate()

        // TODO peut etre en faire un input
        const loadedViews = {'task': true, 'solution': true, 'hints': true, 'editor': true, 'grader': true, 'metadata': true, 'submission': true};
        task.load(loadedViews, () => {
            // loaded
        });
    }

    /***** Event Handlers *****/

    private onMessageReceived = (event) => {
        if (event.data === 'storyLine completed') {
            this.activityDone.emit();
        }
    };

    private onIframeSizeChange(): void {
        if (this.iframeView && !this.isFullscreen) {
            const iframe = this.iframeView.nativeElement;
            iframe.height = '';
            iframe.width = '';
            iframe.height = +this.iframeViewport.nativeElement.offsetHeight;
            iframe.width = +this.iframeViewport.nativeElement.offsetWidth;
            this.isSizeInitDone = true;
        }
    }
}